export function homeJson (language) {
  let items

  if (language === 'es') {
    items = {
      diskChartHome: {
        name: 'diskChartHome',
        label: 'gráfico de disco'
      },
      ramChartHome: {
        name: 'ramChartHome',
        label: 'gráfico de ram'
      },
      connectionsChartHome: {
        name: 'connectionsChartHome',
        label: 'gráfico de conexiones de equipos'
      },
      appsUseTimeChartHome: {
        name: 'appsUseTimeChartHome',
        label: 'gráfico de uso de aplicaciones'
      },
      missingDevicesChartHome: {
        name: 'missingDevicesChartHome',
        label: 'gráfico de equipos faltantes'
      },
      devicesUseTimeChartHome: {
        name: 'devicesUseTimeChartHome',
        label: 'gráfico del tiempo de uso promedio de los equipos'
      },
      devicesConnectionsChartHome: {
        name: 'devicesConnectionsChartHome',
        label: 'gráfico de barras de conexiones de los equipos'
      },
      locationMapHome: {
        name: 'locationMapHome',
        label: 'mapa de ubicaciones de los equipos'
      },
      notificationsHome: {
        name: 'notificationsHome',
        label: 'ver notificaciones'
      }
    }
  } else if (language === 'en') {
    items = {
      diskChartHome: {
        name: 'diskChartHome',
        label: 'disk graph'
      },
      ramChartHome: {
        name: 'ramChartHome',
        label: 'ram graph'
      },
      connectionsChartHome: {
        name: 'connectionsChartHome',
        label: 'devices connection graph'
      },
      appsUseTimeChartHome: {
        name: 'appsUseTimeChartHome',
        label: 'apps usage graph'
      },
      missingDevicesChartHome: {
        name: 'missingDevicesChartHome',
        label: 'missing equipment graph'
      },
      devicesUseTimeChartHome: {
        name: 'devicesUseTimeChartHome',
        label: 'graph of the average usage time of the devices'
      },
      devicesConnectionsChartHome: {
        name: 'devicesConnectionsChartHome',
        label: 'bar graph of device connections'
      },
      locationMapHome: {
        name: 'locationMapHome',
        label: 'map of device locations'
      },
      notificationsHome: {
        name: 'notificationsHome',
        label: 'see notifications'
      }
    }
  }

  return (items)
}
